(function ($, root, undefined) {

    $(function () {
        // 'use strict';

        $(document).ready(function() {

        });
    });
})(jQuery, this);
